import { render, staticRenderFns } from "./websiteMilexContactList.vue?vue&type=template&id=7b8ef302&scoped=true"
import script from "./websiteMilexContactList.vue?vue&type=script&lang=ts"
export * from "./websiteMilexContactList.vue?vue&type=script&lang=ts"
import style0 from "./websiteMilexContactList.vue?vue&type=style&index=0&id=7b8ef302&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ef302",
  null
  
)

export default component.exports